export default {"src":"/_next/static/media/logo.50b9f4d3.svg","height":322,"width":1658,"blurWidth":0,"blurHeight":0};